<div class="mat-dialog-title" fxLayout="row" fxLayoutAlign="space-between center">
  <p>Digite as informações do produto</p>
  <mat-icon class="close-icon" aria-hidden="false" (click)="closeDialog()">close</mat-icon>
</div>

<div class="mat-dialog-content" [formGroup]="productFormGroup">
  <div class="product-container">
    <div class="input-container ean-number-container">
      <mat-label>EAN</mat-label>
      <input type="text" placeholder="000000000000" formControlName="ean" />
    </div>
  </div>
</div>

<div class="mat-dialog-actions">
  <button mat-flat-button class="cancel-btn" (click)="closeDialog()">
    <mat-icon aria-hidden="false">west</mat-icon>
    <span>voltar</span>
  </button>

  <button mat-flat-button class="confirm-btn" (click)="addProduct()">
    <mat-icon aria-hidden="false">add_box</mat-icon>
    <span>Adicionar</span>
  </button>
</div>
